<p>pin-get-started-desktop works!</p>
